import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { UserActivation } from '../models/UserActivation';
import { HttpClient } from '@angular/common/http';
import { Platform } from '@angular/cdk/platform';
import { UserActivationService } from '../Services/Activation/user-activation.service';
import { AESAlgorithm } from '../Utilities/Crypto/AESAlgorithm';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { configuration } from 'src/environments/environment';
@Component({
  selector: 'app-registration-form',
  templateUrl: './registration-form.component.html',
  styleUrls: ['./registration-form.component.css']
})
export class RegistrationFormComponent implements OnInit {
  RegistrationForm: FormGroup;
  userDetails: UserActivation;
  userAgent: any;
  ipAddress: string;
  message: string;
  public resend: boolean = false;
  public isDisabled: boolean = false;
  public link: boolean = false;
  constructor(private formBuilder: FormBuilder, private http: HttpClient, public platform: Platform, private crypto: AESAlgorithm,
    private activation: UserActivationService, private cookieService: CookieService, private router: Router, private toast: ToastrService, private spinner: NgxSpinnerService) {
   if(sessionStorage.getItem('isregister')!=null && sessionStorage.getItem('isregister')!= undefined && sessionStorage.getItem('isregister').toString()!='true')
   {
      if (this.cookieService.get('MD4FacilityId') != null && this.cookieService.get('MD4FacilityId') != '' && this.cookieService.get('MD4FacilityId') != undefined && this.cookieService.get('MD4FacilityId').length != 0) {
      this.router.navigateByUrl('/login');
    }
  }
    this.userAgent = this.getBrowser();
    this.getIp();
    this.message = '';
  }

  ngOnInit() {
    this.RegistrationForm = this.formBuilder.group({
      userId: ['',],
      password: ['',],
      clientkey:['',]
    })
  }

  mapUserModel() {

  }

  registerUser() {
     
    this.activation.getFacilityDetails(this.RegistrationForm.value.clientkey,this.RegistrationForm.value.userId).subscribe(results=>
      {
        if(results!=null)
        {
           
    
    // this.cookieService.set('MD4FacilityId','1',new Date(2050, 1, 25, 13, 30, 30),'/',null,false,"Strict");  
    // sessionStorage.setItem("FacilityId","1");
          configuration.key=results.clientsalt;//'78394567263485273854369834359345';//
          configuration.iv=results.clientkey;//'7839456726348527';//
          if( this.cookieService.get('MD4FacilityId').toString()=='')
          {
            sessionStorage.setItem("RegId",results.facilityId.toString());
          // this.cookieService.set('MD4FacilityId',results.facilityId.toString(),new Date(2050, 1, 25, 13, 30, 30),'/',null,false,"Strict");  
          // sessionStorage.setItem("FacilityId",results.facilityId.toString());
          }
          else{
            var fclt=this.cookieService.get('MD4FacilityId').toString()
            if(!fclt.includes(','))
            {
              if(fclt==results.facilityId.toString())
              {
                alert("Already registered");
                return;
              }
              else{
                fclt=fclt+','+results.facilityId.toString();
                // this.cookieService.set('MD4FacilityId',fclt,new Date(2050, 1, 25, 13, 30, 30),'/',null,false,"Strict");  
                // sessionStorage.setItem("FacilityId",fclt);
              }
            }
            else
            {
              var lstfac=fclt.split(',');
              if(lstfac!=null && lstfac.length>0)
              {
                var chkfacility=lstfac.filter(c=>c==results.facilityId.toString());
                if(chkfacility!=null && chkfacility.length>0)
                {
                  alert("Already registered");
                  return;
                }
                else
                {
                  fclt=fclt+','+results.facilityId.toString();
                 // this.cookieService.set('MD4FacilityId',fclt,new Date(2050, 1, 25, 13, 30, 30),'/',null,false,"Strict");  
                  // sessionStorage.setItem("FacilityId",fclt);
                }
              }
            }
            // fclt=fclt+','+results.facilityId.toString();
            // this.cookieService.set('MD4FacilityId',fclt,new Date(2050, 1, 25, 13, 30, 30),'/',null,false,"Strict");  
            // sessionStorage.setItem("FacilityId",fclt);
          }
        this.isDisabled = true;
        this.resend = false;
        this.message = '';
        this.spinner.show();
        this.userDetails = new UserActivation();
        this.userDetails.userId = this.crypto.encryptor(this.RegistrationForm.value.userId).toString();
        this.userDetails.userAgent = this.getBrowser();
        this.userDetails.ipAddress = this.ipAddress;
        this.userDetails.password = this.RegistrationForm.value.password;
        this.activation.addUserActivationInfo(this.userDetails).subscribe(data => {
          this.spinner.hide();
          this.message = data;
          if (this.message == "Invalid username or password") {
            this.resend = false;
            this.isDisabled = false;
          }
          else {
            this.resend = true;
          }
        })
      }
      else{
        this.toast.error("Invalid Key");
      }

      }

     );
    // this.isDisabled = true;
    // this.resend = false;
    // this.message = '';
    // this.spinner.show();
    // this.userDetails = new UserActivation();
    // this.userDetails.userId = this.crypto.encryptor(this.RegistrationForm.value.userId).toString();
    // this.userDetails.userAgent = this.getBrowser();
    // this.userDetails.ipAddress = this.ipAddress;
    // this.userDetails.password = this.RegistrationForm.value.password;
    // this.activation.addUserActivationInfo(this.userDetails).subscribe(data => {
    //   this.spinner.hide();
    //   this.message = data;
    //   if (this.message == "Invalid username or password") {
    //     this.resend = false;
    //     this.isDisabled = false;
    //   }
    //   else {
    //     this.resend = true;
    //   }
    // })
  }


  getBrowser() {
    switch (true) {
      case this.platform.ANDROID === true:
        {
          return 'ANDROID'
        }
      case this.platform.BLINK === true:
        {
          return 'CHROME'
        }
      case this.platform.EDGE === true:
        {
          return 'EDGE'
        }
      case this.platform.FIREFOX === true:
        {
          return 'FIREFOX'
        }
      case this.platform.SAFARI === true:
        {
          return 'SAFARI'
        }
      case this.platform.TRIDENT === true:
        {
          return 'TRIDENT'
        }
      case this.platform.IOS === true:
        {
          return 'IOS'
        }
      case this.platform.WEBKIT === true:
        {
          return 'WEBKIT'
        }
      default:
        {
          return 'OTHER'
        }
    }
  }

  getIp() {
    const publicIp = require('public-ip');
    try {
      (async () => {
        this.ipAddress = await publicIp.v4();
      })();
    }
    catch (e) {
      console.log(e);
    }
  }

}
